export default [
  {
    path: "/contact",
    page: "index",
    name: "contact",
    meta: {
      sortOrder: 30,
      module: "contact",
      title: "contact",
      drawer: true,
      main: true,
      breadcrumb: "contact",
    },
  },
];
